import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app-auth/services/authentication.service';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { API } from '@app-core/constants/api.constants';
import { StorageService } from '@app-core/services/storage/storage.service';
import { AWS_COGNITO_REGION_KEY } from '@app-core/constants/constants';

@Component({
  selector: 'app-redirection',
  templateUrl: './redirection.component.html',
  styleUrls: ['./redirection.component.scss'],
})
export class RedirectionComponent implements OnInit {
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private router: Router,
    private accessService: AccessService,
    private dataService: DataService,
    private storageService: StorageService
  ) {}

  public ngOnInit() {
    this.listenParams();
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private listenParams() {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => this.validateRedirection(params));
  }

  private validateRedirection(params: any) {
    if (params?.token) {
      const { token, region } = params;

      if (typeof region === 'string' && region.trim() !== '') {
        this.storageService.setStorageValue(AWS_COGNITO_REGION_KEY, region);
      }
      console.log('region', region);
      API.refreshRegion(region);

      this.authService
        .validateRedirection(token)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (loginInfo: any) => {
            this.accessService.setLoginInfo(loginInfo);
            this.dataService.userLogin.next({ loginInfo, redirectUrl: 'home', loginType: loginInfo.loginType });
            console.log('Redirection successful');
          },
          () => {
            console.error('Redirection failed');
            this.accessService.removeLoginInfo();
            this.router.navigate(['callback']);
          }
        );
    } else {
      this.router.navigate(['callback']);
    }
  }
}
